import { render } from "./TermsAndContion.vue?vue&type=template&id=3724e14b&scoped=true"
import script from "./TermsAndContion.vue?vue&type=script&lang=js"
export * from "./TermsAndContion.vue?vue&type=script&lang=js"

import "./TermsAndContion.vue?vue&type=style&index=0&id=3724e14b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3724e14b"]])

export default __exports__